<template>
    <div>
        <h2>Performance in Questions</h2>
        <p>Your average score is {{ averageScore }}%.</p>
        <p>The average score of registered users is {{ overallAverageScore }}%.</p>
        <p>Your score puts you on the {{ percentileRank }}th percentile of registered users.</p>
        <canvas id="userScoresChart"></canvas>
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';
ChartJS.register(BarElement, CategoryScale, LinearScale);

export default {
    extends: Bar,
    props: {
        averageScore: {
            type: Number,
            required: true
        },
        overallAverageScore: {
            type: Number,
            required: true
        },
        percentileRank: {
            type: Number,
            required: true
        },
        userScores: {
            type: Array,
            required: true
        }
    },
    mounted() {
        this.renderChart({
            labels: Array.from({ length: this.userScores.length }, (_, i) => i + 1),
            datasets: [
                {
                    label: 'User Scores',
                    backgroundColor: 'rgba(75, 192, 192, 0.2)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    borderWidth: 1,
                    data: this.userScores
                }
            ]
        }, { responsive: true, maintainAspectRatio: false });
    }
};
</script>

<style scoped>
#userScoresChart {
    max-width: 600px;
    margin: auto;
}
</style>
